<template>
  <div id="vacature-modal" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
      <div class="uk-flex uk-flex-between">
        <div>
          <h3>
            Reageer op vacature:
            <br />
            {{ title }}
          </h3>
        </div>
        <div @click="closeModal()" style="cursor: pointer">
          <span>CLOSE</span>
        </div>
      </div>

      <p>
        Vul hieronder uw gegevens in. Stuur ook uw CV mee. dit kan als bericht, maar ook
        als bijlage.
      </p>

      <div class="uk-padding-small">
        <div>
          <span :class="{ 'val-error': !validationErrors.name }">naam:*</span>
        </div>
        <input type="text" v-model="name" placeholder="voor- en achternaam" />
      </div>

      <div class="uk-padding-small">
        <div>
          <span :class="{ 'val-error': !validationErrors.email }">e-mail:*</span>
        </div>
        <input type="email" v-model="email" placeholder="e-mail adres" />
      </div>

      <div class="uk-padding-small">
        <div>
          <span :class="{ 'val-error': !validationErrors.phone }">telefoon:*</span>
        </div>
        <input type="tel" v-model="phone" placeholder="telefoon-nummer" />
      </div>

      <div class="uk-padding-small">
        <div>
          <span :class="{ 'val-error': !validationErrors.body }">bericht:*</span>
        </div>
        <div>
          <textarea
            v-model="body"
            placeholder="laat hier uw bericht achter en eventueel CV"
          ></textarea>
        </div>
      </div>

      <div class="uk-padding-small uk-padding-remove-top">
        <span class="uk-margin-right">upload CV:</span>
        <br />
        <input
          class="uk-padding-remove uk-margin-small-top"
          type="file"
          id="file"
          ref="file"
        />
      </div>

      <div class="uk-margin-small-top">
        <button class="uk-button uk-button-default" @click="validateFormAndSend()">
          VERSTUUR
        </button>
        <div style="line-height: 1rem">
          <span>{{ succesMessage }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import UIkit from 'uikit';

export default {
  props: ['title'],
  data() {
    return {
      file: '',
      name: '',
      email: '',
      phone: '',
      body: '',
      validationErrors: {
        name: true,
        email: true,
        phone: true,
        body: true,
      },
      succesMessage: '',
    };
  },
  methods: {
    validateFormAndSend() {
      this.validateName();
      this.validateEmail();
      this.validatePhone();
      this.validateBody();

      const succes = Object.values(this.validationErrors).map((val) => val);

      if (succes.includes(false)) return;

      this.sendMessage();
    },
    sendMessage() {
      const messageData = {
        vacature: this.title,
        name: this.name,
        email: this.email,
        phone: this.phone,
        body: this.body,
      };

      const formData = new FormData();
      formData.append('file', this.$refs.file.files[0]);
      formData.append('message-data', JSON.stringify(messageData));

      axios
        .post('mailwithfile.php', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((res) => {
          this.succesMessage = 'Bericht is niet verzonden. Probeer op een andere manier met ons contact op te nemen.';

          if (!res.data) return;

          this.succesMessage = 'Bericht verzonden, wij nemen snel contact met u op!';
          this.resetForm();
        });
    },
    closeModal() {
      this.clearState();
      UIkit.modal('#vacature-modal').hide();
    },
    clearState() {
      this.succesMessage = '';
      this.resetForm();
    },
    resetForm() {
      this.name = '';
      this.email = '';
      this.phone = '';
      this.body = '';
      this.validationErrors.name = true;
      this.validationErrors.email = true;
      this.validationErrors.phone = true;
      this.validationErrors.body = true;
    },
    validateName() {
      const split = this.name.split('');

      if (!split.length) {
        this.validationErrors.name = false;
        return;
      }

      // eslint-disable-next-line no-unused-expressions
      split.includes(' ')
        ? (this.validationErrors.name = true)
        : (this.validationErrors.name = false);
    },
    validateEmail() {
      if (!this.email.length) {
        this.validationErrors.email = false;
        return;
      }
      // eslint-disable-next-line no-useless-escape
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        this.validationErrors.email = true;
      } else {
        this.validationErrors.email = false;
      }
    },
    validatePhone() {
      // eslint-disable-next-line no-unused-expressions
      this.phone.length > 9
        ? (this.validationErrors.phone = true)
        : (this.validationErrors.phone = false);
    },
    validateBody() {
      // eslint-disable-next-line no-unused-expressions
      this.body.length
        ? (this.validationErrors.body = true)
        : (this.validationErrors.body = false);
    },
  },
  mounted() {
    UIkit.util.on('#message-modal', 'beforehide', () => {
      this.clearState();
    });
  },
};
</script>

<style lang="less" scoped>
@import "../assets/vars.less";

textarea {
  resize: none;
  overflow-y: auto;
  width: 14rem;
  height: 11rem;
}

input {
  padding: 0.5rem 1rem;
  width: 12rem;
  border-color: rgb(226, 226, 226);
}

.val-error {
  color: rgb(226, 65, 65);
}

@media screen and (min-width: 901px) {
  h3 {
    font-size: 2rem;
    color: @primary-color;
    text-transform: uppercase;
  }
}

@media screen and (max-width: 900px) {
  h3 {
    font-size: 1rem;
    color: @primary-color;
    text-transform: uppercase;
  }
}
</style>
